import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { BuildingIcon, RefreshCwIcon, WandIcon } from 'lucide-react';
import { collaborationRoles } from '../data/abbviePro';
const iconMap = {
  Snakker: WandIcon,
  AbbVie: BuildingIcon,
  Together: RefreshCwIcon
};
export function CollaborationModelScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-white px-6 py-20" aria-labelledby="collaboration-title" data-id="element-146" data-mp="3dcp5xffvfrc0">
      <div className="mx-auto w-full max-w-5xl" data-id="element-147" data-mp="38e45pg0md7nk">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-148" data-mp="38dcml4o7l2e6">11 - Collaboration model</p>
        <h2 id="collaboration-title" className="max-w-2xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-149" data-mp="3nad4kggllizg">
          Clear roles, fast feedback loops
        </h2>

        <div className="mt-14 grid gap-4 sm:grid-cols-3" data-id="element-150" data-mp="1sxvn5pifxd2q">
          {collaborationRoles.map((role, index) => {
          const Icon = iconMap[role.owner as keyof typeof iconMap];
          return <motion.div key={role.owner} initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl bg-presentation-canvas p-6" data-id="element-151" data-mp="1ga8yp9rs3lzp" data-mpi={index}>
                <Icon className="h-6 w-6 text-abbvie-cyan" aria-hidden="true" data-id="element-152" data-mp="1yynndqeminxc" />
                <h3 className="mt-4 font-bold text-abbvie-navy" data-id="element-153" data-mp="23xqtle6cb06w">{role.owner}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500" data-id="element-154" data-mp="280dhj3zw40yt">{role.responsibility}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}